import { Button, Form, Input, notification, Modal } from "antd";

export default function AlertModal({ showAlertModal, setShowAlertModal }) {
  return (
    <Modal
      visible={showAlertModal}
      onCancel={() => setShowAlertModal(false)}
      footer={null}
      title="Set Queue Alert"
    >
      <Form
        onFinish={(e) => {
          notification["success"]({
            message: "Queue Alert Set",
            description: `You will be notified when the queue number reaches ${e.alertNumber}`,
          });
          setShowAlertModal(false);
        }}
        layout="vertical"
      >
        <Form.Item
          label="Alert me when queue number reaches"
          name="alertNumber"
          rules={[{ required: true }]}
        >
          <Input type="number" min="1" />
        </Form.Item>
        <Button onClick={() => setShowAlertModal(false)} type="default">
          Cancel
        </Button>
        <Button type="primary" htmlType="submit">
          Set Alert
        </Button>
      </Form>
    </Modal>
  );
}